import { render, staticRenderFns } from "./BannerWrapper.vue?vue&type=template&id=2f0982b7&scoped=true"
import script from "./BannerWrapper.vue?vue&type=script&lang=js"
export * from "./BannerWrapper.vue?vue&type=script&lang=js"
import style0 from "./BannerWrapper.vue?vue&type=style&index=0&id=2f0982b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0982b7",
  null
  
)

export default component.exports